// extracted by mini-css-extract-plugin
export default {"leftSide":"LeftSide_leftSide__qprmD","socialIcons":"LeftSide_socialIcons__3Nxvv","slideUp":"LeftSide_slideUp__AlV8S","dark":"LeftSide_dark__2Jq91"};